import merge from 'deepmerge';
import { getErrorToPrint } from '../errorToPrint';
import {
  getHandledErrors as getCommonHandledErrors,
} from './common';
import {
  getHandledErrors as getFlowHandledErrors,
} from './flow';
import { overwriteMerge } from '../../utils/general';

export const getHandledErrors = (flowName, userType, isSelfEmployed = false, goToC2C = false) => {
  const errorToPrint = getErrorToPrint(flowName, userType, isSelfEmployed, goToC2C);

  let commonHandledErrors = getCommonHandledErrors(errorToPrint);
  const flowHandledErrors = getFlowHandledErrors(errorToPrint);

  let flowCommonHandledErrors = {};
  let flowNUserTypeHandledErrors = {};

  if (flowHandledErrors[flowName]) {
    if (flowHandledErrors[flowName].common) {
      flowCommonHandledErrors = flowHandledErrors[flowName].common;
    }
    if (flowHandledErrors[flowName][`user_${userType}`]) {
      flowNUserTypeHandledErrors = flowHandledErrors[flowName][`user_${userType}`];
    }
  }
  flowCommonHandledErrors = merge(flowCommonHandledErrors, flowNUserTypeHandledErrors, { arrayMerge: overwriteMerge });
  commonHandledErrors = merge(commonHandledErrors, flowCommonHandledErrors, { arrayMerge: overwriteMerge });

  return commonHandledErrors;
};
